import { useState } from "react";
import { submitChallengeAnswer, selectProfile } from "./services/authApi";
import SelectProfile from "./CRM/components/modals/SelectProfile";
import useAuthStore from "./states/authStore";
import { usePageTransition } from "@iq/models";

import SecurityQuestionSetup from "./CRM/components/modals/SecurityQuestionSetup";
import SecurityQuestionVerify from "./CRM/components/modals/SecurityQuestionVerify";

const PM_FILTER_SESSION_KEYS = [
  "pm_kanban_selected_project_id",
  "pm_kanban_selected_people_ids",
];

function clearPmFilterSessionState() {
  try {
    PM_FILTER_SESSION_KEYS.forEach((key) => sessionStorage.removeItem(key));
  } catch (err) {
    console.error("Failed clearing PM filter session state", err);
  }
}

function Login() {
    const setProfile = useAuthStore((state) => state.setProfile);
    const bootstrapSession = useAuthStore((state) => state.bootstrapSession);
    const { runTransition } = usePageTransition();
    const [answer, setAnswer] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [candidates, setCandidates] = useState([]);
    const [modal, setModal] = useState(null);
    const [pendingProfile, setPendingProfile] = useState(null);
    const [securityQuestion, setSecurityQuestion] = useState("");

  async function handleSelectProfile(candidate) {
    setError("");
    setLoading(true);
    try {
      const payload = await selectProfile(candidate.id);
      setPendingProfile(payload.profile);
      if (payload.requires_security_setup) {
        setModal("setup");
      } else {
        setSecurityQuestion(payload.security_question);
        setModal("verify");
      }
    } catch (err) {
      setError(err.message || "Could not select profile");
    } finally {
      setLoading(false);
    }
  }

  async function completeLoginFlow() {
    if (!pendingProfile) {
      setError("Profile details are missing");
      return;
    }

    setError("");
    setLoading(true);

    try {
      await runTransition({
        to: "/",
        replace: true,
        preNavigate: async () => {
          clearPmFilterSessionState();
          setProfile(pendingProfile);
          await bootstrapSession();
          setModal(null);
        },
      });
    } catch (err) {
      setError(err.message || "Could not complete login");
    } finally {
      setLoading(false);
    }
  }

  async function handleSetupComplete() {
    await completeLoginFlow();
  }

  async function handleVerifyComplete() {
    await completeLoginFlow();
  }

function handleBackToProfiles() {
  setModal("select");
  setPendingProfile(null);
  setSecurityQuestion("");
}

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const data = await submitChallengeAnswer(answer);

      setCandidates(data.candidates || []);
      setModal("select");
    } catch (err) {
      setError(err.message || "Network error");
    } finally {
      setLoading(false);
    }
  }

return (
      <section className="login-wrap">        
        <div className="login-card">
          <button
            type="button"
            className="login-button"
            onClick={() => runTransition({ to: "/login-client", replace: false })}
            style={{ marginBottom: "12px" }}
          >
            After party sandbox erp
          </button>
          <h1 className="login-title">Who is Mike's 🏀 hero?</h1>
          <p className="login-subtitle">Enter the answer to continue.</p>

          <form onSubmit={onSubmit} className="login-form">
            <input
              className="login-input"
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
              placeholder="Your answer"
              autoComplete="off"
            />
            <button className="login-button" disabled={loading || !answer.trim()}>
              {loading ? "Checking..." : "Continue"}
            </button>
          </form>
          
          {error ? <p className="login-error">{error}</p> : null}
        </div>


        {modal === "select" && (
          <SelectProfile
            candidates={candidates}
            onSelectCandidate={handleSelectProfile}
            onClose={() => setModal(null)}
          />
        )}

        {modal === "setup" && pendingProfile && (
          <SecurityQuestionSetup
            profile={pendingProfile}
            onComplete={handleSetupComplete}
            onBack={handleBackToProfiles}
          />
        )}

        {modal === "verify" && pendingProfile && (
          <SecurityQuestionVerify
            profile={pendingProfile}
            question={securityQuestion}
            onComplete={handleVerifyComplete}
            onBack={handleBackToProfiles}
          />
        )}
        
      </section>
  );
}

export default Login;